import { connect } from 'react-redux'

import GestionParticipants from '../../../pages/settings/participants'
import {
  resetSuccessAction,
  fetchParticipants,
  onSearch,
  pageChanged,
  pageLimitChanged,
  removeError,
  resetParticipantConfig,
} from '../../../redux/participants/actions'

import {
  getParticipants,
  getParticipantsCount,
  getParticipantsListIsLoading,
  getErrorMessage,
  getIsErrorFetch,
  getIsSuccessRefresh,
  getSuccess,
} from '../../../redux/participants/selectors'
import { fetchFilesById } from '../../../redux/formations/actions'
import { getErrorMessageConfig } from '../../../redux/configuration/selectors'
import { removeErrorConfig } from '../../../redux/configuration/actions'
import { getIsErrorFetchFileById } from '../../../redux/formations/selectors'

const mapStateToProps = (state) => ({
  isLoadingParticipantsList: getParticipantsListIsLoading(state),
  participants: getParticipants(state),
  participantsCount: getParticipantsCount(state),
  errorMessage: getErrorMessage(state),
  isErrorFetch: getIsErrorFetch(state),
  isSuccessRefresh: getIsSuccessRefresh(state),
  success: getSuccess(state),
  errorMessageConfig: getErrorMessageConfig(state),
  isErrorFetchFileById: getIsErrorFetchFileById(state),
})

const mapDisptachToProps = (dispatch) => ({
  fetchData: () => {
    dispatch(fetchParticipants())
  },
  pageLimitChanged: (limit) => {
    dispatch(pageLimitChanged(limit))
    dispatch(fetchParticipants())
  },
  pageChanged: (offset) => {
    dispatch(pageChanged(offset))
    dispatch(fetchParticipants())
  },
  removeError: () => dispatch(removeError()),
  removeErrorConfig: () => dispatch(removeErrorConfig()),
  resetSuccessAction: () => dispatch(resetSuccessAction()),
  onCloseReset: () => dispatch(resetParticipantConfig()),

  searchData: (search) => {
    dispatch(onSearch(search))
    dispatch(fetchParticipants())
  },
  fetchFiles: (id) => {
    dispatch(fetchFilesById(id, 'participants'))
  },
})

export default connect(mapStateToProps, mapDisptachToProps)(GestionParticipants)
